import loadLocaleData from './localeDataConfig';

export default function loadIntlData(locale, cb) {
  switch (locale) {
    case 'de':
      require.ensure(
        ['intl', `intl/locale-data/jsonp/de`],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/de');
          loadLocaleData(locale, cb);
        },
        `intl-de`,
      );
      break;
    case 'es':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/es'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/es');
          loadLocaleData(locale, cb);
        },
        'intl-es',
      );
      break;
    case 'fr':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/fr'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/fr');
          loadLocaleData(locale, cb);
        },
        'intl-fr',
      );
      break;
    case 'it':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/it'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/it');
          loadLocaleData(locale, cb);
        },
        'intl-it',
      );
      break;
    case 'nb':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/nb'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/nb');
          loadLocaleData(locale, cb);
        },
        'intl-nb',
      );
      break;
    case 'nl':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/nl'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/nl');
          loadLocaleData(locale, cb);
        },
        'intl-nl',
      );
      break;
    case 'ko':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/ko'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/ko');
          loadLocaleData(locale, cb);
        },
        'intl-it',
      );
      break;
    case 'zh-CN':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/zh-Hans-CN'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/zh-Hans-CN');
          loadLocaleData(locale, cb);
        },
        'intl-zh-CN',
      );
      break;
    case 'zh-TW':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/zh-Hant-TW'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/zh-Hant-TW');
          loadLocaleData(locale, cb);
        },
        'intl-zh-TW',
      );
      break;
    case 'en-GB':
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/en-GB'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/en-GB');
          loadLocaleData(locale, cb);
        },
        'intl-en-GB',
      );
      break;
    default:
      require.ensure(
        ['intl', 'intl/locale-data/jsonp/en'],
        require => {
          require('intl');
          require('intl/locale-data/jsonp/en');
          loadLocaleData(locale, cb);
        },
        'intl-en',
      );
  }
}



// WEBPACK FOOTER //
// ./src/i18n/intlDataConfig.js